export default __webpack_public_path__ + "static/media/img_baseCrochet_lemon.e5b40837.jpg";